import { heroStats } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-5 animate-fade-in">
              热门电视剧免费看全集
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight animate-fade-in-up">
              亚洲影视网
              <br />
              <span className="text-primary-500">高清在线追剧平台</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 mt-4 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
              全网最新最全免费电视剧在线观看
            </p>

            <p className="text-sm md:text-base text-foreground-500 mt-5 max-w-[560px] lg:max-w-none leading-relaxed animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              亚洲影视网汇聚海量热门电视剧资源，涵盖国产剧、韩剧、日剧、泰剧、美剧等全品类。无需注册会员，全部免费观看，每日更新 200+ 集，1080P 高清画质流畅不卡顿。无论你是古装仙侠爱好者，还是悬疑推理迷，在这里都能找到心仪好剧。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mt-6 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-8 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                开始免费追剧
              </a>
              <a
                href="#topics"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-8 py-3 border border-background-300 text-foreground-700 font-medium rounded-lg hover:border-primary-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                浏览热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:max-w-[520px] animate-slide-in-right">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20Asian%20TV%20drama%20collage%20with%20warm%20amber%20and%20crimson%20lighting%2C%20traditional%20costume%20drama%20elegant%20scene%20blending%20with%20modern%20urban%20drama%20neon%20cityscape%2C%20artistic%20double%20exposure%20style%2C%20rich%20golden%20and%20deep%20red%20tones%2C%20dramatic%20cinematic%20composition%2C%20luxurious%20texture&width=1040&height=780&seq=hero-main-visual&orientation=landscape"
                alt="亚洲影视网免费电视剧高清在线追剧"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
                <span className="text-white text-xs font-medium">今日已更新 217 集新剧</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}